import split from 'lodash/split';
import axios from 'axios';
import * as types from '../constants/ActionTypes';
import { setURLQuery } from '../../lib/page';

const ARTICLE_URL = '/smarthelp/article-content';

function requestArticle() {
  return { type: types.REQUEST_MACHINE_ARTICLE };
}

function receiveArticle(responseData) {
  return {
    type: types.RECEIVE_MACHINE_ARTICLE_RESPONSE,
    payload: responseData,
  };
}

function receiveArticleError() {
  return { type: types.RECEIVE_MACHINE_ARTICLE_ERROR };
}


function fetchMachineArticle({ faqId, locale }) {
  return (dispatch) => {
    dispatch(requestArticle());
    const faq = split(faqId, ',')[0];
    let articleURL = `${ARTICLE_URL}?article_id=${faq}`;

    if (locale) {
      articleURL = setURLQuery(articleURL, 'locale', locale);
    }

    return axios.get(articleURL)
    .then(response => (
      dispatch(receiveArticle(response.data.articleContent))
    ))
    .catch(() => {
      dispatch(receiveArticleError());
    });
  };
}


module.exports = {
  fetchMachineArticle,
};
